
import axios from 'axios'


function getTree() {
    return axios.get(`${process.env.VUE_APP_APIURL}/tree`)
        .then(resp => {
            return resp.data
        })
}

async function moveNodes(changesOfNodes) {
    for (let action of changesOfNodes) {
        if(action.draggingNode.data.nodeType=="point"){
            await axios.put(`${process.env.VUE_APP_APIURL}/point/${action.draggingNode.data._id}`,{
                tagGroup: action.dropNode.data._id,
                name: action.draggingNode.data.name,
                tagCode:action.draggingNode.data.tagCode,
                type:action.draggingNode.data.type,
                referenceFrequency: 10,
            }).then((res)=>{
                return res.data
            })
        }else{
            await axios.put(`${process.env.VUE_APP_APIURL}/tree/group/${action.draggingNode.data._id}`,{
                name: action.draggingNode.data.name,
                tagCode: action.draggingNode.data.tagCode,
                parent: action.dropNode.data._id,
            }).then((res)=>{
                return res.data
            })
        }
    }
}
export default {
    getTree,
    moveNodes
};